import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import SalesAgentLibrary from "./components/pages/SalesAgentLibrary";
import CustomerServiceAgentLibrary from "./components/pages/CustomerServiceAgentLibrary";
import MarketingAgentLibrary from "./components/pages/MarketingAgentLibrary";
import OperationsAgentLibrary from "./components/pages/OperationsAgentLibrary";
import LeadQualificationAgent from "./components/pages/LeadQualificationAgent";
import LeadAssignmentAgent from "./components/pages/LeadAssignmentAgent";
import SalesOrderCreationAgent from "./components/pages/SalesOrderCreationAgent";
import QuoteGenerationAgent from "./components/pages/QuoteGenerationAgent";
import CustomerSupportEmailResponderAgent from "./components/pages/CustomerSupportEmailResponderAgent";
import SmartFollowUpEmailAgent from "./components/pages/SmartFollowUpEmailAgent";
import DynamicQueryResolutionAgent from "./components/pages/DynamicQueryResolutionAgent";
import ContentResearchAIAgent from "./components/pages/ContentResearchAIAgent";
import BrandVoiceAnalyzerAgent from "./components/pages/BrandVoiceAnalyzerAgent";
import SocialMediaContentGeneratorAgent from "./components/pages/SocialMediaContentGeneratorAgent";
import OrderEntryManagementAgent from "./components/pages/OrderEntryManagementAgent";
import TechnicalLanguageInterpreterAgent from "./components/pages/TechnicalLanguageInterpreterAgent";
import CareFollowUpNotificationAgent from "./components/pages/CareFollowUpNotificationAgent";
import CreditCardOriginationAgent from "./components/pages/CreditCardOriginationAgent";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/agent-library/sales" element={<SalesAgentLibrary />} />
          <Route path="/agent-library/customer-service" element={<CustomerServiceAgentLibrary />} />
          <Route path="/agent-library/marketing" element={<MarketingAgentLibrary />} />
          <Route path="/agent-library/operations" element={<OperationsAgentLibrary />} />
          <Route path="/agent-library/sales/lead-qualification" element={<LeadQualificationAgent />} />
          <Route path="/agent-library/sales/lead-assignment" element={<LeadAssignmentAgent />} />
          <Route path="/agent-library/sales/sales-order-creation" element={<SalesOrderCreationAgent />} />
          <Route path="/agent-library/sales/quote-generation" element={<QuoteGenerationAgent />} />
          <Route path="/agent-library/customer-service/email-responder" element={<CustomerSupportEmailResponderAgent />} />
          <Route path="/agent-library/customer-service/follow-up-email" element={<SmartFollowUpEmailAgent />} />
          <Route path="/agent-library/customer-service/query-resolution" element={<DynamicQueryResolutionAgent />} />
          <Route path="/agent-library/marketing/content-research" element={<ContentResearchAIAgent />} />
          <Route path="/agent-library/marketing/brand-voice-analyzer" element={<BrandVoiceAnalyzerAgent />} />
          <Route path="/agent-library/marketing/social-media-generator" element={<SocialMediaContentGeneratorAgent />} />
          <Route path="/agent-library/operations/order-entry" element={<OrderEntryManagementAgent />} />
          <Route path="/agent-library/operations/tech-language-interpreter" element={<TechnicalLanguageInterpreterAgent />} />
          <Route path="/agent-library/operations/care-follow-up" element={<CareFollowUpNotificationAgent />} />
          <Route path="/agent-library/operations/credit-card-origination" element={<CreditCardOriginationAgent />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;